import { getCurrentTime, getPlaySpeed } from 'src/core/getters';

export function getNextFrameTime(delta: number) {
  const currentTime = getCurrentTime();
  const playSpeed = getPlaySpeed();

  return currentTime + delta * 1000 * playSpeed;
}
